import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadAdsCampaignMetric } from '@tinct/core-api-models';
import { ApiCollectionResponse } from '../../types';
import { ApiError, tinctApi } from '../../api';
import { GetAdsCampaignMetricsParams } from '../../endpoints/crm-integrations';

export const getAdsCampaignMetrics = async (
  params: GetAdsCampaignMetricsParams,
): Promise<ApiCollectionResponse<ReadAdsCampaignMetric>> => {
  return await tinctApi.crmIntegrations.getAdsCampaignMetrics(params);
};

/** Daily metrics of one synced ad campaign over an inclusive date window. */
export const useGetAdsCampaignMetrics = (
  params: GetAdsCampaignMetricsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadAdsCampaignMetric>, ApiError>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: [
      'ads-campaign-metrics',
      params.integrationId,
      params.adsCampaignId,
      params,
    ],
    queryFn: () => getAdsCampaignMetrics(params),
    enabled: !!params.integrationId && !!params.adsCampaignId,
    ...options,
  });
